<template>
  <div class="supplierEntryInfo_box">
    <Form ref="supplierEntryInfoForm" :rules="supplierEntryInfoValidate" :model="supplierEntryInfoForm"
      :label-width="labelWidth" autocomplete="off" @submit.native.prevent>
      <Row type="flex" justify="center">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1001174')" prop="mobile">
            <Input v-model.trim="supplierEntryInfoForm.mobile" size="large" :placeholder="$t('key1001001')" clearable
              style="width:400px" @on-blur="blurInput">
              <span slot="prepend">{{ $t('key1001574') }} +86</span>
            </Input>
            <span v-if="registered">{{ $t('key1006513') }}</span>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1006507')" prop="imageCode">
            <div class="flex justify-content-between align-items-center" style="width:400px">
              <Input type="text" clearable size="large" style="width: 270px"
                v-model.trim="supplierEntryInfoForm.imageCode" :placeholder="$t('key1001002')">
              </Input>
              <img :alt="$t('key1001003')" class="cursor" width="110" height="40" :src="captchaImage"
                @click="getCaptcha('update')"/>
            </div>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1005488')" prop="mobileSms">
            <div class="flex justify-content-between align-items-center" style="width:400px">
              <Input type="text" clearable size="large" style="width: 270px" autocomplete="off"
                v-model.trim="supplierEntryInfoForm.mobileSms" :placeholder="$t('key1006508')">
              </Input>
              <Button size="large" class="ml20" :style="languagesVal === 'zh-CN' ? 'width: 110px' : 'width: 168px'"
                :disabled="!(supplierEntryInfoForm.mobile && supplierEntryInfoForm.imageCode) || talgCode"
                @click="sendVerificationCode">{{ codeText }}</Button>
            </div>
          </FormItem>
        </Col>
        <template v-if="!registered">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1006509')" prop="password">
              <Input type="password" v-model.trim="supplierEntryInfoForm.password" size="large"
                :placeholder="$t('key1006510')" autocomplete="off" clearable style="width:400px">
              </Input>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1006511')" prop="password1">
              <Input type="password" v-model.trim="supplierEntryInfoForm.password1" size="large"
                :placeholder="$t('key1006512')" autocomplete="off" clearable style="width:400px">
              </Input>
            </FormItem>
          </Col>
        </template>
      </Row>
      <Row type="flex" style="width: 400px; margin-left: 120px;">
        <div class="flex align-items-start mb20">
          <Checkbox v-model="readTalg" class="mr5">
            <span>{{ $t('key1006514') }}</span>
          </Checkbox>
          <div class="distributorThemeColor font-size-12 cursor" @click="gotoTermsOfService">{{ $t('key1000077') }}</div>
          <div class="mr4 ml4 font-size-12">{{ $t('key1000520') }}</div>
          <div class="distributorThemeColor font-size-12 cursor" @click="gotoPrivacyPolicy">{{ $t('key1000078') }}</div>
        </div>
        <Button type="primary" style="width: 100%" @click="nextStepBtn" :disabled="!readTalg"
          size="large">{{ $t('key1002560') }}</Button>
      </Row>
    </Form>
    <!--服务条款弹窗-->
    <supplierServiceTermsModal ref="termService"></supplierServiceTermsModal>
    <!--隐私政策弹窗-->
    <supplierPrivacyPolicyModal ref="privacyPolicy"></supplierPrivacyPolicyModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import supplierServiceTermsModal from "@/views/shopping/login/components/supplierServiceTermsModal.vue";
import supplierPrivacyPolicyModal from "@/views/shopping/login/components/supplierPrivacyPolicyModal.vue";

export default {
  name: "supplierEntryInfo",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      supplierEntryInfoForm: {
        adid: null,
        email: null, // 邮箱
        imageCode: null,  // 图片验证码
        mobile: '', // 手机号
        mobileSms: null, // 手机短信验证码
        password: '', // 密码
        password1: '', // 确认密码
        uid: null
      },
      supplierEntryInfoValidate: {
        mobile: [{required: true, validator: v.validateMobile(), trigger: 'blur'}],
        imageCode: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000989'), trigger: 'blur'}],
        mobileSms: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000990'), trigger: 'blur'}],
        password: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000143'), trigger: 'blur'},
          {min: 8, max: 26, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006500'), trigger: 'blur'}
        ],
        password1: [{validator: v.validatenewPassword(), required: true, trigger: 'blur'}]
      },
      captchaImage: '',
      codeText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000988'),
      talgCode: false,
      readTalg: false,
      captchaTimer: null,
      currentIndex: 0, // 最多自动更新10次
      registered: false,
    };
  },
  mounted() {
    let v = this;
    v.$nextTick(() => {
      v.$refs['supplierEntryInfoForm'].resetFields();
    });
  },
  created() {
    let v = this;
    v.getCaptcha();
    v.startCaptchaTimer();
  },
  methods: {
    // 获取图片验证码
    getCaptcha(type) {
      let v = this;

      // 获取当前的时间戳
      function handleCaptcha() {
        v.axios.get(api.yms_get_captcha).then((response) => {
          let data = response.data.datas;
          if (data) {
            if (type !== 'update') {
              v.currentIndex += 1;
            }
            v.captchaImage = 'data:image/png;base64,' + data.base64ImageCode;
            v.uid = data.uid;
            v.supplierEntryInfoForm.uid = data.uid;
          }
        });
      }

      if (type === 'update') {
        handleCaptcha(type);
      } else {
        if (v.currentIndex <= 10) {
          handleCaptcha();
        } else {
          v.stopCaptchaTimer();
        }
      }
    },
    //  开始定时器，180秒之后更新图形验证码
    startCaptchaTimer() {
      this.captchaTimer = setInterval(this.getCaptcha, 180 * 1000); // 每180秒刷新一次验证码
    },
    // 清除定时器
    stopCaptchaTimer() {
      clearInterval(this.captchaTimer);
    },
    // 发送手机验证码
    sendVerificationCode() {
      let v = this;
      let talg = false;
      v.$refs['supplierEntryInfoForm'].validateField("mobile", (error) => {
        if (!error) {
          v.$refs['supplierEntryInfoForm'].validateField("imageCode", (error) => {
            if (!error) {
              talg = true;
            }
          });
        }
      });
      if (talg) {
        let query = {
          code: v.supplierEntryInfoForm.imageCode, // 图片的验证码
          isValidHasRegistry: 0, // 校验是否已注册 1:要校验
          isvalid: 1, // 1 校验图片验证码  0 不校验
          messageType: 1, //  类型 1 注册 2 找回密码 3 绑定手机 4找回邮箱 5 登录
          mobile: v.supplierEntryInfoForm.mobile,
          uid: this.uid,
          mobileCountryCode: '86'
        };
        v.talgCode = true;
        v.axios.post(api.post_ymsUserSetting_sendMobileVerificationCode, query, {
          loading: true
        }).then(response => {
          if (response.data.code === 0) {
            let time = 60;
            clearInterval(v.timeStop);
            v.timeStop = setInterval(() => {
              time--;
              if (time > 0) {
                v.codeText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000995') + time + 'S';
                v.talgCode = true;
              } else {
                time = 60;
                v.codeText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000988');
                clearInterval(v.timeStop); //清除定时器
                v.talgCode = false;
              }
            }, 1000);
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000996'));
          } else {
            v.talgCode = false;
          }
        });
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006501'));
        return false;
      }
    },
    // 隐私政策
    gotoPrivacyPolicy() {
      this.$refs['privacyPolicy'].supplierPrivacyPolicyModal = true;
    },
    // 服务条款
    gotoTermsOfService() {
      this.$refs['termService'].supplierServiceTermsModal = true;
    },
    // 下一步
    nextStepBtn() {
      let v = this;
      if (v.readTalg) {
        let {password1, ...obj} = v.supplierEntryInfoForm;
        let params = Object.assign({}, obj);
        params.mobileCountryCode = '86';
        v.$refs['supplierEntryInfoForm'].validate((valid) => {
          if (valid) {
            v.axios.post(api.post_ymsSupplierMerchant_registry, params, {loading: true}).then(response => {
              if (response.data.code === 0) {
                let data = response.data.datas;
                v.stopCaptchaTimer();
                v.$Modal.success({
                  title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006502'),
                  content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006503'),
                  okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000732'),
                  onOk: () => {
                    v.$emit('registerSuccess', data);
                  },
                  onCancel: () => {
                  }
                });
              }
            });
          }
        });
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006504'));
        return false;
      }
    },
    // 校验新密码与旧密码
    validatenewPassword() {
      let v = this;
      let password = function (rule, value, callback) {
        if (!value) {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006505')));
        } else if (v.supplierEntryInfoForm.password !== value) {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006506')));
        } else {
          callback();
        }
      };
      return password;
    },
    // 验证开通手机号 0 未注册任何商户 1 仅注册分销商 2 已注册供应商 3 已被注册其他商户
    blurInput() {
      this.registered = false;
      let mobile = this.supplierEntryInfoForm.mobile;
      if (mobile) {
        this.axios.get(api.get_ymsSupplierMerchant_validateMobileOrEmail + mobile).then(res => {
          if (res.data.code === 0) {
            let data = res.data.datas;
            if (data) {
              this.registered = data === 1;
            }
          }
        });
      }
    }
  },
  beforeDestroy() {
    this.stopCaptchaTimer();
  },
  components: {
    supplierServiceTermsModal,
    supplierPrivacyPolicyModal
  }
};
</script>

<style lang="less" scoped>
.supplierEntryInfo_box {
  width: 650px;
  margin: 40px auto;

  /deep/ .ivu-form-item-label {
    padding-right: 0 !important;
    font-size: 14px;
  }

  /deep/ .ivu-input-group-prepend {
    font-size: 13px;
    padding: 6px 20px;
  }

  /deep/ .ivu-input {
    font-size: 14px;
  }
}
</style>